
import errorHandler from './errorHandler'
import api from '../../api'

export function replyMention(payload, next){
        api.post('/instagram/mentionedcomments/' + payload.query.repliedMessageId + '.reply', payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        })   
    }



// WEBPACK FOOTER //
// ./src/libs/instagram/replyMention.js